module.exports = __webpack_public_path__ + "img/ennetix-users-page-office-zone-tab.ce6f804a.png";